import $axios from "@/plugins/axios";

/*
  对应的报刊类型列表
  @param {
    page {number} 分页页码，数字类型
    limit {number} 每页数据
    is_shop_cart_count {1 ：需要购物车数量。2：不需要} 
  } 
  @response {
    count: {number} 总数量
    lists: {Array} 数据列表
    shop_cart_count: {number} 购物车数据
  }
*/ 
export const queryNotices = params => $axios(
  {
    url: "/v1/notice/lists",
    params,
    method: 'GET',
  },
  {
    loading: true,
    loadingMsg: '正在获取数据...',
    code_message_show: true,
  },
);

/*
  服务公告详情
  @param {
    id {number} 
  } 
  @response {
    count: {number} 总数量
    lists: {Array} 数据列表
    shop_cart_count: {number} 购物车数据
  }
*/ 
export const queryNoticeDetail = params => $axios(
  {
    url: "/v1/notice/detail",
    params,
    method: 'GET',
  },
  {
    loading: true,
    loadingMsg: '正在获取数据...',
    code_message_show: true,
  },
);

/*
  网站信息
  @param {
    id {number} 
  } 
  @response {
    count: {number} 总数量
    lists: {Array} 数据列表
    shop_cart_count: {number} 购物车数据
  }
*/ 
export const querySiteInfo = params => $axios(
  {
    url: "/v1/web_config/view_base_info",
    params,
    method: 'GET',
  },
  {
    code_message_show: true,
  },
);

/*
  网站信息 - 用户协议
  @param {
  } 
  @response {
  }
*/ 
export const queryUserProtocol = params => $axios(
  {
    url: "/v1/web_config/user_agreement",
    params,
    method: 'GET',
  },
  {
    code_message_show: true,
  },
);

/*
  网站信息 - 隐私政策
  @param {
  } 
  @response {
  }
*/ 
export const queryPrivacyPolicy = params => $axios(
  {
    url: "/v1/web_config/privacy_policy",
    params,
    method: 'GET',
  },
  {
    code_message_show: true,
  },
);
